import React from 'react';
import { useTranslation } from 'react-i18next';

interface QuickActionsProps {
    onAction: (command: string) => void;
    onUndo: () => void;
    onRedo: () => void;
    onDone: () => void;
    disabled: boolean;
}

const QuickActions: React.FC<QuickActionsProps> = ({ onAction, onUndo, onRedo, onDone, disabled }) => {
    const { t } = useTranslation(['conversationalEditor']);

    return (
        <div className="ce-quick-actions">
            <div className="ce-quick-actions__row">
                <button
                    className="ce-quick-actions__btn"
                    onClick={() => onAction('Remove all filler words')}
                    disabled={disabled}
                >
                    {t('conversationalEditor:removeFillers')}
                </button>
                <button
                    className="ce-quick-actions__btn"
                    onClick={onUndo}
                    disabled={disabled}
                >
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M3 7h8M3 7l3-3M3 7l3 3" />
                    </svg>
                    {t('conversationalEditor:undo')}
                </button>
                <button
                    className="ce-quick-actions__btn"
                    onClick={onRedo}
                    disabled={disabled}
                >
                    {t('conversationalEditor:redo')}
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M11 7H3M11 7l-3-3M11 7l-3 3" />
                    </svg>
                </button>
            </div>
            <button
                className="ce-quick-actions__done"
                onClick={onDone}
                disabled={disabled}
            >
                {t('conversationalEditor:done')}
            </button>
        </div>
    );
};

export default QuickActions;
